<ion-item>

  <ion-thumbnail slot="start">
    <img [src]="item.avatar || 'assets/img/empty-img/no_user.png'" alt="">
  </ion-thumbnail>

  <ion-label>

    <div class="title">{{ item.usuario }}</div>

    <div class="time">
      <yu-icon name="clock"></yu-icon>

      <p>
        <span>{{ item.hora_inicio }}</span> a <span>{{ item.hora_fin ? item.hora_fin : '--:--' }}</span>

        @if (item.fin_next) {
          <sup>+1</sup>
        }

        @if (item.local) {
          en <span>{{ item.local }}, {{ item.departamento }}</span>
        }
      </p>
    </div>

  </ion-label>

</ion-item>
